export default "__VITE_ASSET__Dr1$huUI__"